// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gcBV","question":"styles_question__2jNFH","description":"styles_description__kzhVE"};